import React from 'react';
import c from 'classnames';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import type { RelatedContentProps } from './types';

import './style.scss';

// Subcomponents.
import MoreButton from './MoreButton';
import Title from './Title';

interface Subcomponents {
  MoreButton: typeof MoreButton;
  Title: typeof Title;
}

const RelatedContent: React.FC<RelatedContentProps> & Subcomponents = ({
  className,
  children,
  ...restProps
}) => {
  const classes = c('RelatedContent', 'content-section', 'mb-0', className);

  return (
    <div className={classes} {...restProps}>
      <Container>
        <div className="RelatedContent__inner">
          {children}
        </div>
      </Container>
    </div>
  );
};

RelatedContent.MoreButton = MoreButton;
RelatedContent.Title = Title;

export default RelatedContent;
